import toType from "utilities/request/toType";
import _ from 'lodash';

var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

export default function buildParams(prefix, obj, traditional, add) {
	var name;
	if(Array.isArray(obj)) {

		// Serialize array item.
		_.each(obj, function(value, index) {
			if(traditional || rbracket.test(prefix)) {

				// Treat each array item as a scalar.
				add(prefix, value);

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + (typeof value === "object" && value != null ? index : "") + "]",
					value,
					traditional,
					add
				);
			}
		});

	} else if(!traditional && toType(obj) === "object") {

		// Serialize object item.
		for(name in obj) {
			buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
		}

	} else {

		// Serialize scalar item.
		add(prefix, obj);
	}
}